module.exports = __webpack_public_path__ + "media/flags/no-75c2c58c.svg";